import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import IntlMessages from "../../helpers/IntlMessages";

const PopupAnnouncement = () => {
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);
    return (
        <div>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                    <span className="font-weight-bold">
                        <IntlMessages id="announcement.popupSubject" />
                    </span>
                </ModalHeader>
                <ModalBody>
                    <IntlMessages id="announcement.popupBody" />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        <IntlMessages id="user.close" />
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default PopupAnnouncement;
